import React from 'react';

import { MDText } from 'i18n-react';

import { config } from 'Components/steps/config/howItWorksConfig';
import { Steps } from 'Components/steps/Steps';
import { Content } from 'LegacySBCRA/Content/Content';
import { HeadlineStats } from 'Storybook/components/local/HeadlineStats';

import { RoundedSection } from '../../common/RoundedSection/RoundedSection';

import Texts from './HowItWorks.json';

import styles from './HowItWorks.scss';

const LocalT = new MDText(Texts);

const HowItWorks = () => (
  <div className={styles.view}>
    <RoundedSection withBottomLedge theme="primary-yellow">
      <Content
        center
        className={styles.hero}
        wrapper={{ className: styles.contentWrapper }}
      >
        <div className={styles.content}>
          <h1 className={styles.title}>{LocalT.translate('hero.title')}</h1>
          <h4 className={styles.subTitle}>{LocalT.translate('hero.copy')}</h4>
        </div>
      </Content>
    </RoundedSection>
    <RoundedSection withBottomLedge withTopLedge>
      <Content center>
        <Steps withNumber className={styles.steps} config={config} />
      </Content>
    </RoundedSection>
    <RoundedSection withBottomLedge withTopLedge className={styles.headlineStatsWrapper} theme="primary-yellow">
      <Content center className={styles.headlineStatsContentWrapper}>
        <h2>{LocalT.translate('statsTitle')}</h2>
        <HeadlineStats
          stats={[
            {
              stat: String(LocalT.translate('stats.0.stat')),
              subtitle: LocalT.translate('stats.0.subtitle'),
            },
            {
              stat: String(LocalT.translate('stats.1.stat')),
              subtitle: LocalT.translate('stats.1.subtitle'),
            },
            {
              stat: String(LocalT.translate('stats.2.stat')),
              subtitle: LocalT.translate('stats.2.subtitle'),
            },
          ]}
        />
      </Content>
    </RoundedSection>
  </div>
);

export default HowItWorks;
